"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SynergyIdTextInput = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var models_1 = require("../../../models");
var ErrorMessage_1 = require("../ErrorMessage");
var Input_1 = require("../Input");
var PropertyInputWrapper_1 = require("../PropertyInputWrapper");
var InputWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 100%;\n  width: 316px;\n"], ["\n  max-width: 100%;\n  width: 316px;\n"])));
var SynergyIdTextInput = function (_a) {
    var propertyId = _a.propertyId, placeholder = _a.placeholder, onChange = _a.onChange, onBlur = _a.onBlur, value = _a.value, errorMessages = _a.errorMessages, disabled = _a.disabled, className = _a.className, displayError = _a.displayError;
    var handleChange = function (e) {
        onChange(e.target.value);
    };
    var handleBlur = function (e) {
        if (onBlur) {
            onBlur(e.target.value);
        }
    };
    return (react_1.default.createElement(PropertyInputWrapper_1.PropertyInputWrapper, { propertyId: propertyId, propertyType: models_1.AUTH_PROPERTY_COLUMN_TYPE.synergyId, inputFormatType: models_1.SYNERGY_ID_AUTH_PROPERTY_TYPE.free, errorMessages: errorMessages, className: className, displayError: displayError },
        react_1.default.createElement(InputWrapper, null,
            react_1.default.createElement(Input_1.Input, { "data-cy-property-item": true, error: displayError, value: value, type: "text", placeholder: placeholder, onChange: handleChange, onBlur: handleBlur, disabled: disabled, name: propertyId, id: propertyId, "aria-invalid": displayError, "aria-errormessage": ErrorMessage_1.getFieldErrorMessageId(propertyId) }))));
};
exports.SynergyIdTextInput = SynergyIdTextInput;
var templateObject_1;
